import { useTranslation } from 'react-i18next'
import type { QuotedOutcome, StockbetOutrightsResponse } from '@brochure/shared'
import { hasSelection, type DraftSlip } from '@/lib/slip'
import { outrightNames } from '@/lib/stockbet'
import { cn } from '@/lib/utils'
import { MatchMarkets } from './MatchMarkets'

type OutrightsTabProps = {
  data: StockbetOutrightsResponse
  slip: DraftSlip
  /** Ospite iscritto: ogni esito quotato entra in schedina, anche la propria squadra (spec 4). */
  canPick: boolean
  onPick: (o: QuotedOutcome) => void
}

/**
 * Antepost (spec 4): vincitore, finalista e capocannoniere del torneo, con le caselle della pagina partita. Chiudono
 * appena il girone finisce e si genera la fase a eliminazione; le squadre eliminate non compaiono. Un torneo da 2
 * squadre parte dalla finale: tutto chiuso o deciso dall'inizio, e la tab mostra la nota «chiusi» con gli esiti senza quota.
 */
export function OutrightsTab({ data, slip, canPick, onPick }: OutrightsTabProps) {
  const { t } = useTranslation()
  if (data.markets.length === 0) return <p data-testid="outrights-empty" className="font-body text-paper/60">{t('stockbet.outrights.empty')}</p>
  const isClosed = data.markets.every((m) => m.status !== 'open')
  // Torneo finito: tutti i mercati decisi, non solo chiusi (vincitori in verde, giocate liquidate).
  const isFinished = data.markets.every((m) => m.status === 'decided')
  const note = isFinished ? 'finished' : isClosed ? 'closed' : 'intro'
  return (
    <div className="space-y-3">
      <p
        data-testid={`outrights-${note}`}
        className={cn('rounded-2xl border px-4 py-3 font-body text-sm', isFinished ? 'border-sun/40 bg-sun/10 text-sun' : isClosed ? 'border-coral/40 bg-coral/10 text-coral' : 'border-paper/15 bg-paper/5 text-paper/80')}
      >
        {t(`stockbet.outrights.${note}`)}
      </p>
      <MatchMarkets markets={data.markets} group="outrights" names={outrightNames(data)} sides={{}} canPick={canPick} isPicked={(o) => hasSelection(slip, null, o)} onPick={onPick} />
    </div>
  )
}
